import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { IOffice, IOrderType } from "@lib";
import ControlComponent from "@core/components/alt-ui/controls/control.component";
import AltIcon from "@/core/components/alt-icon";
import { OrderBlockInfoHandler } from "./order-block-info-handler";

@Component({
    components: { ControlComponent, AltIcon },
})
export default class OrderCreateInfo extends Vue {
    @Prop({ required: true })
    private handler!: OrderBlockInfoHandler;

    @Prop({ default: () => null })
    private office!: IOffice | null;

    @Prop({ default: () => null })
    private orderType!: IOrderType | null;

    @Watch("orderType", { immediate: true, deep: true })
    private onOrderTypeChanged(): void {
        this.initValues();
    }

    @Watch("office", { immediate: true, deep: true })
    private onOfficeChanged(): void {
        this.initValues();
    }

    private initValues(): void {
        this.handler.init(this.office, this.orderType);
    }
}
